import { useCallback } from 'react';

import { matchPath, useLocation } from 'react-router-dom';

export const useHandlePath = () => {
    const { pathname, search } = useLocation();
    const handleCheckPath = useCallback(
        (path: string) => {
            const redirectPath = decodeURIComponent(path);
            const fullPath = search ? `${pathname}${search}` : pathname;

            const encodedFullPath = matchPath(redirectPath, decodeURIComponent(fullPath));
            const matchesPathname = Boolean(encodedFullPath);

            return matchesPathname ? undefined : redirectPath;
        },
        [pathname, search],
    );
    return { handleCheckPath };
};
